import React from "react";

function ProjectDetailsStep({ handleChange, formData, notify }) {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (
        [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "image/png",
          "image/jpeg",
          "image/jpg",
        ].includes(file.type) &&
        file.size <= 10485760
      ) {
        handleChange({ target: { name: "file-upload", value: file } });
      } else {
        notify(
          "Please upload a valid file format (PDF, DOC/DOCX, PNG, JPG/JPEG) and the size must not exceed 10MB."
        );
        e.target.value = ""; // Reset input
      }
    }
  };

  const handleFileRemove = () => {
    handleChange({ target: { name: "file-upload", value: null } });
  };

  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="pt-3 mt-3">
          <h2 className="h6 color_grey mb-2">
            Please Tell Us a Bit About Your Project.
          </h2>
          <p className="nda__info mb-4">
            All information you share in this section will be protected under a
            non-disclosure agreement (NDA) and will not be shared with third
            parties.
          </p>
        </div>

        <div className="col-lg-12">
          <div className="row row-cols-1 row-cols-sm-1 g-3 g-sm-4 pb-3 pb-sm-4 mb-xl-2">
            <div className="col">
              <label className="form-label">Example Web Link</label>
              <div className="position-relative">
                <i className="fi-link position-absolute top-50 start-0 translate-middle-y fs-lg ms-3"></i>
                <input
                  type="url"
                  className="form-control form-control-lg form-icon-start"
                  id="example-website"
                  name="example-website"
                  placeholder="https://website.com"
                  onChange={handleChange}
                  value={formData["example-website"] || ""}
                  style={{ maxWidth: "500px", paddingLeft: "45px" }}
                />
              </div>
            </div>
            <div className="col mb-5">
              <label className="form-label">
                Project File (pdf, doc/docx, png, jpg, jpeg - max: 10MB)
              </label>
              <div
                className="d-flex align-items-center justify-content-center position-relative h-100 bg-body-tertiary border border-2 border-dotted rounded p-3"
                style={{ maxWidth: "500px" }}
              >
                {!formData["file-upload"] ? (
                  <>
                    <input
                      type="file"
                      id="file-upload"
                      name="file-upload"
                      hidden
                      accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                      onChange={handleFileChange}
                    />
                    <div
                      className="text-center cursor-pointer"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                    >
                      <i className="fi-plus-circle fs-4 text-secondary-emphasis mb-2"></i>
                      <div className="hover-effect-underline stretched-link fs-sm fw-medium">
                        Upload File
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div>
                      {formData["file-upload"].name ? (
                        <span style={{ fontSize: "13px", fontWeight: "600" }}>
                          {formData["file-upload"].name}
                        </span>
                      ) : (
                        "Uploaded file"
                      )}
                    </div>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={handleFileRemove}
                      type="button"
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Please Provide Some
                Information About Your Project.
              </label>
              <textarea
                className="form-control form-control-lg bg-transparent"
                id="project-details"
                name="project-details"
                placeholder="Project Details."
                rows="6"
                onChange={handleChange}
                value={formData["project-details"] || ""}
                style={{ maxWidth: "500px" }}
              />
            </div>
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Budget You Plan to Allocate
                for the Project
              </label>
              <div className="vstack gap-2">
                {[
                  "1,000 - 5,000",
                  "5,000 - 10,000",
                  "10,000 - 25,000",
                  "25,000 - 50,000",
                  "50,000 - 100,000",
                  "100,000 +",
                ].map((range, index) => (
                  <div className="form-check mb-1" key={index}>
                    <input
                      type="radio"
                      className="form-check-input"
                      id={`budget-${index}`}
                      name="budget"
                      value={range}
                      onChange={handleChange}
                      checked={formData.budget === range}
                    />
                    <label
                      htmlFor={`budget-${index}`}
                      className="form-check-label position-relative"
                      style={{ paddingLeft: "19px" }}
                    >
                      <i
                        className="fi-dollar-sign fs-lg position-absolute top-50 start-0 translate-middle-y ms-0"
                        style={{ bottom: "-5px" }}
                      ></i>
                      {range}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectDetailsStep;
